import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconDownload from '~/components/svg/download.svg';
import Config from '~/config';

const ButtonDownloadIllust = ({ t, onClick, role, loading }) => {
  const roles = Config.getRoles();

  return (
    <>
      <button className="btn-download-illust" onClick={onClick}>
        {loading ? (
          <FontAwesomeIcon
            style={{ marginRight: 16, width: 24 }}
            icon={faSpinner}
            pulse
          />
        ) : (
          <IconDownload style={{ width: 20, marginRight: 16 }} />
        )}
        {t('Download')}
      </button>
      <style jsx>
        {`
          .btn-download-illust {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 44px;
            font-size: 16px;
            color: #ffffff;
            font-weight: 600;
            margin-top: 16px;
            border-radius: 40px;
            width: 100%;
            border: none;
            ${!role || role === roles.GUEST
              ? 'background: #E3E3E3;'
              : 'background: #d73a4e;'}
          }
          .btn-download-illust:hover {
            opacity: ${!role || role === roles.GUEST ? '1' : '0.8'};
          }
        `}
      </style>
    </>
  );
};

export default ButtonDownloadIllust;
